// extracted by mini-css-extract-plugin
export default {"hsError":"GetCompanyCodeForm_hsError__B2WY0","inputHolder":"GetCompanyCodeForm_inputHolder__3BS1b","buttonHolder":"GetCompanyCodeForm_buttonHolder__NCY1Z"};